import UploadFilesService from '../services/upload.service';

export const Uploads = {
  state: {
    images: [],
  },

//********************************************************************GETTERS*****************************************************************************************
//********************************************************************************************************************************************************************

  getters: {
    allImages: (state) => state.images,
    currentImage: (state) => state.images.filter(i => i.isCurrent == true),
  },

//********************************************************************ACTIONS*****************************************************************************************
//********************************************************************************************************************************************************************

  actions: {

    getAllImages({ commit }) {
      return UploadFilesService.getImages().then(
        response => {
          commit('setImages', response.data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    updateImage({ commit }, data) {
      return UploadFilesService.setCurrent(data.id).then(
        response => {
          commit('updImage', data);
          return Promise.resolve(response);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
  },

  mutations: {

    setImages: (state, images) => (state.images = images),
    updImage: (state, updatedImage) => {
      const current = state.images.filter(images => images.isCurrent == true);
      const index1 = state.images.findIndex(images => images.id == current[0].id);
      current[0].isCurrent = false;
      if (index1 !== -1) {
        state.images.splice(index1, 1, current[0]);
      }
      const index2 = state.images.findIndex(images => images.id === updatedImage.id);
      updatedImage.isCurrent = true;
      if (index2 !== -1) {
        state.images.splice(index2, 1, updatedImage);
      }
    },
  },
}
